import { useTheme } from '@mui/material';

import { MenuIconProps } from './menu-icon-props.interface';

export const HomeMenuIcon = ({ stroke, filled, ...props }: MenuIconProps) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return filled ? (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9717 3.41586C11.6275 2.9388 12.5366 2.97311 13.1562 3.5184L19.6562 9.23812L19.79 9.36996C20.084 9.69085 20.2499 10.1119 20.25 10.5516V18.9998C20.2498 19.9662 19.4664 20.7498 18.5 20.7498H14.3496C13.7976 20.7496 13.3498 20.3019 13.3496 19.7498V14.6502C13.3496 14.3741 13.1258 14.1502 12.8496 14.1502H11.1504C10.8742 14.1502 10.6504 14.3741 10.6504 14.6502V19.7498C10.6502 20.3019 10.2024 20.7496 9.65039 20.7498H5.5C4.53361 20.7498 3.75017 19.9662 3.75 18.9998V10.5516C3.75013 10.0489 3.96643 9.57026 4.34375 9.23812L10.8438 3.5184L10.9717 3.41586Z"
        fill={strokeColor}
      />
    </svg>
  ) : (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 10.5522V19.0001C4.5 19.5524 4.94772 20.0001 5.5 20.0001H9.65C9.78807 20.0001 9.9 19.8882 9.9 19.7501V13.65C9.9 13.5119 10.0119 13.4 10.15 13.4H13.85C13.9881 13.4 14.1 13.5119 14.1 13.65V19.7501C14.1 19.8882 14.2119 20.0001 14.35 20.0001H18.5C19.0523 20.0001 19.5 19.5524 19.5 19.0001V10.5522C19.5 10.2648 19.3764 9.99135 19.1606 9.8015L12.6606 4.08137C12.2829 3.74898 11.7171 3.74898 11.3394 4.08137L4.83936 9.8015C4.62363 9.99135 4.5 10.2648 4.5 10.5522Z"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </svg>
  );
};
